// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Smile = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Smile = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Smile = _exports.Smile = function Smile(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10.0013 18.9587C5.05964 18.9587 1.04297 14.942 1.04297 10.0003C1.04297 5.05866 5.05964 1.04199 10.0013 1.04199C14.943 1.04199 18.9596 5.05866 18.9596 10.0003C18.9596 14.942 14.943 18.9587 10.0013 18.9587ZM10.0013 2.29199C5.7513 2.29199 2.29297 5.75033 2.29297 10.0003C2.29297 14.2503 5.7513 17.7087 10.0013 17.7087C14.2513 17.7087 17.7096 14.2503 17.7096 10.0003C17.7096 5.75033 14.2513 2.29199 10.0013 2.29199ZM13.543 8.33366C13.543 7.49199 13.1013 6.87533 12.5013 6.87533C11.9013 6.87533 11.4596 7.49199 11.4596 8.33366C11.4596 9.17533 11.9013 9.79199 12.5013 9.79199C13.1013 9.79199 13.543 9.17533 13.543 8.33366ZM8.54297 8.33366C8.54297 7.49199 8.1013 6.87533 7.5013 6.87533C6.9013 6.87533 6.45964 7.49199 6.45964 8.33366C6.45964 9.17533 6.9013 9.79199 7.5013 9.79199C8.1013 9.79199 8.54297 9.17533 8.54297 8.33366ZM13.8346 12.8753C14.043 12.6003 13.993 12.2087 13.718 12.0003C13.443 11.792 13.0513 11.842 12.843 12.117C12.1596 13.017 11.1263 13.5337 10.0096 13.5337C8.89296 13.5337 7.8513 13.0003 7.18463 12.117C6.9763 11.842 6.58464 11.7837 6.30964 11.992C6.03464 12.2003 5.9763 12.592 6.18463 12.867C7.08463 14.067 8.51796 14.7837 10.0096 14.7837C11.5013 14.7837 12.918 14.0837 13.843 12.867L13.8346 12.8753Z",
      fill: "#212B36"
    }));
  };
});
